/* ~/app/router.options.ts在Nuxt3下会被自动加载，用于完全自定义页面路由 */
/*   https://nuxt.com/docs/4.x/guide/recipes/custom-routing */
/*   Nuxt4中，~ 已经从Nuxt3中的根目录，默认变为了 app/，所以~/app/router.options.ts，对应变为 app/router.options.ts */
/*   在该项目中，为了行为统一，已经在 nuxt.config.ts 中设置了hook函数 'pages:routerOptions'，用于明确加载改文件 */
import type { RouterConfig } from '@nuxt/schema'
import type {RouteRecordRaw} from 'vue-router'

import routes from '@/router/routes'

export default {
  /* 如果将 routes 字段设为null，或undefined，则使用Nuxt默认的路由 */
  routes: (_routes: readonly RouteRecordRaw[]) => {
    /* 入参是Nuxt根据 ~/pages/ 目录下的文件结构自动创建好的路由 */
    /*   并且 _routes 还会受到 nuxt.config.ts 中的hook函数 'pages:extend' 的影响 */
    /*   当前项目已经在hook函数 'pages:extend' 中清空了Nuxt默认创建的路由，所以这里入参会为空数组 */

    /* 返回值为 RouteRecordRaw[] 数组，参考：https://router.vuejs.org/api/interfaces/RouterOptions.html#routes */
    return routes
  },

  /* satisfies关键字用法可参考：https://zhuanlan.zhihu.com/p/1968636253655265682 */
} satisfies RouterConfig
